/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect } from 'react';
import Appbar from '../../components/Appbar/Appbar';
import { useNavigate } from 'react-router-dom';
import { Button, CircularProgress, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ToggleButtons from '../../components/ToggleListAndGrid/ToggleButtonGroup';
import './background.css';
import PanelsView from '../../components/ListAndGridView/PanelsView';
import { fetchAdminPanels, fetchAdminSearchedPanels, fetchPanelsAndEstates, getSearchedPanelsForInstaller } from '../../redux/actions/panelEstateActions';
import { useTypedDispatch } from '../../redux/dispatchActionTypes/dispatchAndThunkActionTypes';
import NewEstateModal from '../../components/NewEstate/NewEstateModal';
import { useSelector } from 'react-redux';
import { setPanelView } from '../../redux/actions/specificPanelActions';
import { ROLES } from '../../entities/Constants';
import PanelsOverView from '../../components/ListAndGridView/PanelsOverView';
import ManagePanelsModal from '../../components/ManagePanelsAndEstatesModal/ManagePanelsModal';
import { fetchEstatesAndPanels, fetchPanelsInEstate } from '../../redux/actions/managePanelsAndEstatesActions';
import { CurrentUserProps, EstateProps } from '../../components/ListAndGridView/panelEstateTypes';
import { setMenuSelected } from '../../redux/actions/settingsActions';
import Loader from '../../components/CircularLoader/Loader';
import { useTranslation } from 'react-i18next';
import secureLocalStorage  from  "react-secure-storage";
import FolderIcon from '@mui/icons-material/Folder';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(0),
}));

export function Panels(): JSX.Element {
    const dispatch = useTypedDispatch();
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.down('md'));
    const role = secureLocalStorage.getItem('role')
    const { currentUser } = useSelector((state:any) => state.userReducer)
    const { t } = useTranslation();
    const [view, setView] = React.useState('list');
    const [open, setOpen] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [managePanelsOpen, setManagePanelsOpen] = React.useState(false);
    const { estates, unassignedPanels } = useSelector((state: any) => state.userReducer);
    const { panelView } = useSelector((state: any) => state.specificPanelAndEstateReducer);
    const { panelsInEstate } = useSelector((state: any) => state.managePanelsAndEstatesReducer);
    const [panelsInEstates, setPanelsInEstates] = React.useState([unassignedPanels].concat(panelsInEstate));
    const [count, setCount] = React.useState(0);
    const [movePanel, setMovePanel] = React.useState(false);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [search, setSearch] = React.useState('');
    const [filterArray, setFilterArray] = React.useState<Array<any>>([]);
    const [loading, setLoading] = React.useState(false);

    

    useEffect(() => {
        if (panelView === 'list') {
            secureLocalStorage.setItem('view', 'list');
            dispatch(setPanelView('list'));
        }
        setView(panelView);

        if (panelView === '') {
            const viewType: any = secureLocalStorage.getItem('view') || '';
            if (viewType !== '') {
                setView(viewType);
            } else {
                setView('list');
            }
        }

        const fetching = async () => {
            if(role === ROLES?.ADMIN){
                //setDataLoaded(false);
                if(search.length >= 3)
                await dispatch(fetchAdminSearchedPanels(search))
                //setDataLoaded(true);
            }else if(role===ROLES?.INSTALLER){                
                if(search.length >= 3){
                    setLoading(true)
                    await dispatch(getSearchedPanelsForInstaller(search))
                }
                await dispatch(fetchPanelsAndEstates());
                setLoading(false)
            }
            else{
            //setDataLoaded(false);
            await dispatch(fetchPanelsAndEstates());
           // setDataLoaded(true);
            }
        }
        setTimeout(()=>{
            setDataLoaded(true);
        }, 3000)

        fetching()
        /*************** For development purpose till resolve CORS issue SCG-1172 *************/
        // fetch('https://partner.eatonsecureconnect.cloud/m2m-web-admin/rest/auth/currentuser', {
        //     method: 'GET',
        //     credentials: 'include',
        // })
        //     .then((res) => res.json())
        //     .then((data) => { localStorage.setItem('role', data.userType)
        //                         localStorage.setItem('estate',JSON.stringify(data))
        //                     });
    }, [search]);

    const handleOpen = (): void => {
        setOpen(true);
    };
    const handleManagePanelsModal = async () => {
        try{
        await dispatch(
            fetchPanelsInEstate(
                estates.sort((a: EstateProps, b: EstateProps) => {
                    if (a.ID !== undefined && b.ID !== undefined) {
                        return a.ID - b.ID;
                    }
                })
            )
        );
            }
            catch(e){console.log(e)}
        await dispatch(fetchEstatesAndPanels(currentUser));
        setMovePanel(false);
        setTimeout(() => {
            setManagePanelsOpen(true);
        },1000)
    };

    console.log(estates)

    const handleChange = (event: React.MouseEvent<HTMLElement>, nextView: string) => {
       secureLocalStorage.setItem('view', nextView);
        setView(nextView);
    };
    const title = `${t('menu_oveview')}`;
    return (
        <>
        <div className="main-div">
            <div style={md ?{}: {maxHeight:'100vh',overflow:'auto'}}>
                <Appbar toolbarMenu={false} title={title} />
                {md ? (
                    <div style={{ backgroundColor: '', }}>
                        {!dataLoaded && (
                            <Loader />
                        )}
                        <Box sx={{ flexGrow: 1, marginLeft: 0, marginRight: 0, marginTop: 1, mb: 2 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Item elevation={1}>
                                        <PanelsOverView filterArray={filterArray} setFilterArray={setFilterArray}/>
                                    </Item>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ flexGrow: 1, marginLeft: 0, marginRight: 0, mb: 3 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={11.7}>
                                    <Item sx={{ float: 'right' }} elevation={0}>
                                        <ToggleButtons view={view} handleChange={handleChange} />
                                    </Item>
                                </Grid>
                            </Grid>
                        </Box>
                    </div>
                ) : (
                    <Box sx={{ flexGrow: 1, marginLeft: 10, marginRight: 10, marginTop: 5 }}>
                        {!dataLoaded && (
                            <Loader />
                        )}
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Item elevation={1}>
                                    <PanelsOverView filterArray={filterArray} setFilterArray={setFilterArray}/>
                                </Item>
                            </Grid>                           
                            <Grid item xs={8}>
                                {(role === 'INSTALLER' ||
                                    role === 'MANAGER') &&
                                    <Box>
                                        <Button
                                            sx={{ backgroundColor: "#fff" }}
                                            variant="outlined"
                                            onClick={handleOpen}
                                        >
                                            <FolderIcon fontSize="small" />
                                            &nbsp;&nbsp;{t('lbl_newEstate')}
                                        </Button>
                                        <NewEstateModal path='panels' open={open} setOpen={setOpen} />
                                    </Box>}
                            </Grid>                            
                            <Grid item xs={4}>
                                <Item sx={{ float: 'right' }} elevation={0}>
                                    <ToggleButtons view={view} handleChange={handleChange} />
                                </Item>
                            </Grid>
                        </Grid>
                    </Box>
                )}
                {md ? (
                    <div style={{ backgroundColor: '', maxHeight: '60vh', overflow: 'auto' }}>
                        <Box sx={{ flexGrow: 1, marginLeft: 1, marginRight: 1, marginTop: 0 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <PanelsView path='panels' search={search} setSearch={setSearch} page={page} setPage={setPage} view={view} filterArray={filterArray} setFilterArray={setFilterArray} loading={loading}/>
                                </Grid>
                                <Grid item xs={12}></Grid>
                                <Grid item xs={12}></Grid>
                            </Grid>
                        </Box>
                    </div>
                ) : (
                    <>
                        <Box sx={{ flexGrow: 1, marginLeft: 7, marginRight: 7, marginTop: 4 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <PanelsView path='panels' search={search} setSearch={setSearch} page={page} setPage={setPage} view={view} filterArray={filterArray} setFilterArray={setFilterArray} loading={loading}/>
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                )}
                {md && (
                    <>
                        {(role === 'INSTALLER' ||
                            role === 'MANAGER') &&
                            <Paper
                                sx={{
                                    zIndex:1000,
                                    position: 'fixed',
                                    top: '100dvh',
                                    transform: 'translateY(-100%)',
                                    width: '100%',
                                    p: 2,
                                    backgroundColor: 'white',
                                    borderRadius: 0,
                                    boxShadow: '0px -3px 5px -1px rgba(0, 0, 0, 0.2), 0px -6px 10px rgba(0, 0, 0, 0.14), 0px -1px 18px rgba(0, 0, 0, 0.12)',
                                }}

                            >
                                <Box sx={{ flexGrow: 1, marginLeft: 0, marginRight: 0 }}>
                                    <Grid container spacing={2}>                                        
                                        {currentUser?.userType !== 'ADMIN' &&
                                            <Grid item xs={12}>
                                                <Box>
                                                    <Button
                                                        disabled={
                                                            currentUser?.userType === 'ENGINEER' ||
                                                            currentUser?.userType === 'OFFICE_STAFF'
                                                        }
                                                        fullWidth
                                                        variant="outlined"
                                                        sx={{ fontSize: 13 }}
                                                        onClick={handleOpen}
                                                    >
                                                        <FolderIcon sx={{ fontSize: 15 }} />
                                                        &nbsp;&nbsp;{t('lbl_newEstate')}
                                                    </Button>
                                                    <NewEstateModal path='panels' open={open} setOpen={setOpen} />
                                                </Box>
                                            </Grid>}
                                    </Grid>
                                </Box>
                            </Paper>}
                    </>
                )}
                </div>
            </div>
        </>
    );
}